import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/OurManagementPage/MangementSection/MangementSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/Common/FooterCard/FooterCard.tsx");
